$(document).ready(function(){


    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }
    
    // Function to set the value of a cookie
    function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = `expires=${date.toUTCString()}`;
        document.cookie = `${name}=${value}; ${expires}; path=/`;
    }
    
    // Function to calculate and update the startAt count
    function calcRead() {
        var startAt = parseInt(getCookie('startAt')) || 125221; // Get startAt from cookie or default to 125221
        var actRead = 1; // Assuming each page load increments the read count by 1
        var endRead = startAt + actRead;
        var formattedEndRead = endRead.toLocaleString(); // Format endRead
        $('.customers_read').html(formattedEndRead);
        setCookie('startAt', endRead, 365); // Store updated startAt in cookie for 1 year
    }

    calcRead();

    $('.Landing_reviews_inner').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 2000,
        responsive: [
            {
            breakpoint: 700,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '40px',
                infinite: true,
                dots: true
            }
            }
        ]
      });
});